module.exports = __webpack_public_path__ + "img/men'sclothing.2c347957.jpg";